/**
 * Projekte archive: AJAX category filter + pagination.
 */
(function () {
	var root = document.querySelector('[data-projekte-archive]');
	if (!root || typeof didapressProjekteArchive === 'undefined') {
		return;
	}

	var list = root.querySelector('[data-projekte-archive-list]');
	if (!list) {
		return;
	}

	function parseIds(value) {
		if (Array.isArray(value)) {
			return value
				.map(function (id) {
					return parseInt(id, 10) || 0;
				})
				.filter(function (id) {
					return id > 0;
				});
		}

		return String(value || '')
			.split(',')
			.map(function (id) {
				return parseInt(id, 10) || 0;
			})
			.filter(function (id) {
				return id > 0;
			});
	}

	function serializeIds(ids) {
		return parseIds(ids)
			.slice()
			.sort(function (a, b) {
				return a - b;
			})
			.join(',');
	}

	function idsEqual(a, b) {
		return serializeIds(a) === serializeIds(b);
	}

	function toggleId(ids, id) {
		var next = parseIds(ids);
		var index = next.indexOf(id);

		if (index === -1) {
			next.push(id);
		} else {
			next.splice(index, 1);
		}

		return next;
	}

	var state = {
		page: parseInt(root.getAttribute('data-page') || '1', 10) || 1,
		produkt: parseIds(root.getAttribute('data-produkt')),
		schulform: parseIds(root.getAttribute('data-schulform')),
		loading: false,
	};

	function updateUrl() {
		try {
			var url = new URL(window.location.href);
			if (state.page > 1) {
				url.searchParams.set('projekte_page', String(state.page));
			} else {
				url.searchParams.delete('projekte_page');
			}
			if (state.produkt.length) {
				url.searchParams.set('projekte_produkt', serializeIds(state.produkt));
			} else {
				url.searchParams.delete('projekte_produkt');
			}
			if (state.schulform.length) {
				url.searchParams.set('projekte_schulform', serializeIds(state.schulform));
			} else {
				url.searchParams.delete('projekte_schulform');
			}
			url.searchParams.delete('projekte_cat');
			window.history.replaceState({}, '', url.toString());
		} catch (e) {}
	}

	function scrollToList() {
		var top = root.getBoundingClientRect().top + window.pageYOffset - 100;
		window.scrollTo({ top: top, behavior: 'smooth' });
	}

	function load(page, produkt, schulform, shouldScroll) {
		if (state.loading) {
			return;
		}

		state.loading = true;
		root.classList.add('is-loading');

		var body = new FormData();
		body.append('action', 'didapress_projekte_archive');
		body.append('nonce', didapressProjekteArchive.nonce);
		body.append('page', String(page));
		body.append('produkt', serializeIds(produkt));
		body.append('schulform', serializeIds(schulform));

		fetch(didapressProjekteArchive.ajaxUrl, {
			method: 'POST',
			credentials: 'same-origin',
			body: body,
		})
			.then(function (response) {
				return response.json();
			})
			.then(function (payload) {
				if (!payload || !payload.success || !payload.data || typeof payload.data.html !== 'string') {
					throw new Error('invalid');
				}

				state.page = payload.data.page || page;
				state.produkt = parseIds(payload.data.produkt);
				state.schulform = parseIds(payload.data.schulform);
				root.setAttribute('data-page', String(state.page));
				root.setAttribute('data-produkt', serializeIds(state.produkt));
				root.setAttribute('data-schulform', serializeIds(state.schulform));
				list.innerHTML = payload.data.html;
				updateUrl();

				if (shouldScroll) {
					scrollToList();
				}
			})
			.catch(function () {
				window.alert(didapressProjekteArchive.i18n.error);
			})
			.finally(function () {
				state.loading = false;
				root.classList.remove('is-loading');
			});
	}

	root.addEventListener('click', function (event) {
		var filterBtn = event.target.closest('[data-projekte-filter]');
		if (filterBtn && root.contains(filterBtn)) {
			event.preventDefault();
			var group = filterBtn.getAttribute('data-projekte-filter-group') || '';
			var termId = parseInt(filterBtn.getAttribute('data-projekte-filter') || '0', 10) || 0;
			if (!termId) {
				return;
			}

			var nextProdukt = state.produkt.slice();
			var nextSchulform = state.schulform.slice();

			if (group === 'produktkategorien') {
				nextProdukt = toggleId(nextProdukt, termId);
			} else if (group === 'schulformen') {
				nextSchulform = toggleId(nextSchulform, termId);
			} else {
				return;
			}

			if (idsEqual(nextProdukt, state.produkt) && idsEqual(nextSchulform, state.schulform) && state.page === 1) {
				return;
			}

			load(1, nextProdukt, nextSchulform, true);
			return;
		}

		var pageBtn = event.target.closest('[data-projekte-page]');
		if (pageBtn && root.contains(pageBtn)) {
			event.preventDefault();
			var nextPage = parseInt(pageBtn.getAttribute('data-projekte-page') || '1', 10) || 1;
			var pageProdukt = parseIds(pageBtn.getAttribute('data-projekte-produkt') || serializeIds(state.produkt));
			var pageSchulform = parseIds(pageBtn.getAttribute('data-projekte-schulform') || serializeIds(state.schulform));
			if (nextPage === state.page && idsEqual(pageProdukt, state.produkt) && idsEqual(pageSchulform, state.schulform)) {
				return;
			}
			load(nextPage, pageProdukt, pageSchulform, true);
		}
	});
})();
